import { produce } from "immer";

import type { NavigatorFilters, SelectedNavigatorFilters } from "../types";

export default function useNavigatorFilters(
  selectedFilters: SelectedNavigatorFilters,
  setSelectedFilters: (selectedFilters: SelectedNavigatorFilters) => void,
) {
  function clearFilterType(type: string) {
    setSelectedFilters(
      selectedFilters.filter((selectedFilter) => selectedFilter.type !== type),
    );
  }
  function updateFilterValue(
    type: string,
    updateType: "include" | "exclude" | "clear",
    value: NavigatorFilters[number]["values"][number],
  ) {
    const selectedFilter = selectedFilters.find(
      (filter) => filter.type === type,
    );

    if (selectedFilter) {
      const selectedValue = selectedFilter.values.find(
        ({ id }) => id === value.id,
      );
      if (selectedValue) {
        if (updateType === "clear") {
          if (selectedFilter.values.length === 1) {
            clearFilterType(type);
          } else {
            setSelectedFilters(
              produce(selectedFilters, (draftSelectedFilters) => {
                for (let i = 0; i < draftSelectedFilters.length; i += 1) {
                  if (draftSelectedFilters[i].type === type) {
                    draftSelectedFilters[i].values = draftSelectedFilters[
                      i
                    ].values.filter(({ id }) => id !== value.id);
                  }
                }
              }),
            );
          }
        } else {
          setSelectedFilters(
            produce(selectedFilters, (draftSelectedFilters) => {
              for (let i = 0; i < draftSelectedFilters.length; i += 1) {
                if (draftSelectedFilters[i].type === type) {
                  for (
                    let j = 0;
                    j < draftSelectedFilters[i].values.length;
                    j += 1
                  ) {
                    if (draftSelectedFilters[i].values[j].id === value.id) {
                      draftSelectedFilters[i].values[j].selectionType =
                        updateType === "include" ? "INCLUDED" : "EXCLUDED";
                    }
                  }
                }
              }
            }),
          );
        }
      } else {
        setSelectedFilters(
          produce(selectedFilters, (draftSelectedFilters) => {
            for (let i = 0; i < draftSelectedFilters.length; i += 1) {
              if (draftSelectedFilters[i].type === type) {
                draftSelectedFilters[i].values.push({
                  ...value,
                  selectionType:
                    updateType === "include" ? "INCLUDED" : "EXCLUDED",
                });
              }
            }
          }),
        );
      }
    } else {
      setSelectedFilters([
        ...selectedFilters,
        {
          type,
          values: [
            {
              ...value,
              selectionType: updateType === "include" ? "INCLUDED" : "EXCLUDED",
            },
          ],
        },
      ]);
    }
  }
  function setFilterValue(
    type: string,
    filterValue: NavigatorFilters[number]["values"][number],
  ) {
    setSelectedFilters([
      ...selectedFilters.filter(
        (selectedFilter) => selectedFilter.type !== type,
      ),
      {
        type,
        values: [{ ...filterValue, selectionType: "INCLUDED" }],
      },
    ]);
  }
  return { updateFilterValue, setFilterValue, clearFilterType };
}
